module.exports = __webpack_public_path__ + "img/icon-walk.35052cce.svg";